import * as Sentry from '@sentry/react'
import shouldErrorBeLoggedToSentry from 'utils/shouldErrorBeLoggedToSentry'
import type RootStore from 'store'

export const sentryLog = (
  error: Error,
  extra: Record<string, unknown> = {}
) => {
  if (shouldErrorBeLoggedToSentry(error)) {
    Sentry.captureException(error, {
      extra: { ...extra },
    })
  }
}

export const sentryLogWithState = (error: Error, rootStore: RootStore) => {
  const { userStore, uiStore, messagesStore } = rootStore
  const lastMessage = messagesStore?.lastMessage
  sentryLog(error, {
    isLoggedIn: userStore.isLoggedIn,
    userHasLoggedIn: userStore.userHasLoggedIn,
    theme: uiStore.theme.id,
    isProductSearch: messagesStore.isProductSearch,
    lastMessageIntent: lastMessage?.messageObject.intent,
    lastMessageType: lastMessage?.messageObject.type,
    errorMessage: error.message,
  })
}
